import { Button } from "@/components/ui/button";

const STATUS_COLORS = {
  offered: "bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
  accepted: "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  signed: "bg-zinc-100 text-zinc-700 dark:bg-white/[0.06] dark:text-zinc-300",
  cancelled: "bg-zinc-100 text-zinc-500 dark:bg-white/[0.04] dark:text-zinc-400",
  declined: "bg-red-50 text-red-600 dark:bg-red-500/15 dark:text-red-400",
  countered: "bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
};

export default function VenueOutbox({
  sentContacts,
  isSentLoading,
  outgoingUnread,
  onOpenThread,
  getContactPeerLabel,
}) {
  return (
    <section className="panel p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold tracking-tight text-zinc-900 dark:text-zinc-50">
          Sent{outgoingUnread ? (
            <span className="ml-2 inline-flex items-center justify-center rounded-full bg-amber-500 px-1.5 py-0.5 text-xs font-semibold text-zinc-950">
              {outgoingUnread}
            </span>
          ) : ""}
        </h2>
        {isSentLoading && (
          <span className="text-xs text-zinc-400">Loading...</span>
        )}
      </div>
      {sentContacts.length === 0 ? (
        <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">No messages sent yet.</p>
      ) : (
        <div className="mt-4 grid gap-2">
          {sentContacts.map((c) => (
            <div
              key={c.id}
              className="flex items-center justify-between gap-3 rounded-xl border border-zinc-200/60 bg-white/60 p-4 dark:border-white/[0.07] dark:bg-white/[0.03]"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {!c.read && (
                    <span className="inline-flex h-1.5 w-1.5 rounded-full bg-amber-500" title="Unread" />
                  )}
                  <span className="text-sm font-semibold text-zinc-900 dark:text-zinc-100 truncate">
                    {c.peer_name || getContactPeerLabel(c)}
                  </span>
                  {c.booking?.status && (
                    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide ${STATUS_COLORS[c.booking.status] ?? STATUS_COLORS.signed}`}>
                      {c.booking.status}
                    </span>
                  )}
                </div>
              </div>
              <Button
                type="button"
                className="btn-secondary text-xs shrink-0"
                onClick={() => onOpenThread(c)}
              >
                Open
              </Button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
